import { ADDRESSES_SUCCESS, ADDRESSES_LOADING, ADDRESSES_ERROR } from 'helpers/types';

const INITIAL_STATE = {
  addresses: [],
  error: false,
  loading: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADDRESSES_SUCCESS:
      return {
        addresses: action.payload,
        error: false,
        loading: false,
      };
    case ADDRESSES_ERROR:
      return {
        addresses: [],
        error: action.payload,
        loading: false,
      };
    case ADDRESSES_LOADING:
      return {
        addresses: [],
        error: false,
        loading: true,
      };
    default:
      return state;
  }
}
